import { render, staticRenderFns } from "./ExpenseSettings.vue?vue&type=template&id=4731d35e"
import script from "./ExpenseSettings.vue?vue&type=script&lang=js"
export * from "./ExpenseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports